import React, { useMemo, useState } from 'react';

import { useForm } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  UpdateProviderConfigFormContext,
  UpdateProviderConfigFormState,
  updateProviderConfigFormStateDefault,
  updateProviderConfigSchemaDefault,
} from '@Forms/providers/UpdateProviderConfigFormContext';

export const UpdateProviderConfigFormProvider: React.FC<{ children: JSX.Element }> = ({
  children,
}) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<UpdateProviderConfigFormState>>>(
    updateProviderConfigSchemaDefault
  );
  const methods = useForm({
    defaultValues: updateProviderConfigFormStateDefault,
    resolver: yupResolver(schema),
  });
  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, setSchema, methods]);

  return (
    <UpdateProviderConfigFormContext.Provider value={value}>
      {children}
    </UpdateProviderConfigFormContext.Provider>
  );
};
